import transformRequest from './helpers/transform';

/**
 * This transform Layer is used by component Featured
 */

/**
 * This method return a Request object after delete unnecessary paramter
 * @param {*} request Request Object pass to client request API axios at this moment
 */
const transformRequestFeatured = (request) => {
  // params to delete don't matter the value store
  const paramsDelete = ['uiDatesYearsAdjustmentPatch', 'airlineIataCode', 'siteEdition', 'airport'];

  // params to delete when has empty value
  const paramsEmpty = [
    'origins',
    'destinations',
    'outputCurrencies',
    'markets',
    'currencyPricingSettings',
    'travelClasses',
  ];

  const cleanRequest = transformRequest(request, paramsDelete, paramsEmpty);

  return cleanRequest;
};

export default transformRequestFeatured;
